import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";

const Card = ({ url, short }) => (
  <div className="card-print bg-[#08080A] text-white flex items-center gap-[0.18in] px-[0.2in] overflow-hidden"
    style={{ width: "3.5in", height: "2in", outline: "1px dashed #6b6b6b", outlineOffset: "-0.5px", WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}>
    <div className="bg-white p-[0.06in] rounded-sm shrink-0">
      <QRCodeSVG value={url} size={104} level="M" />
    </div>
    <div className="min-w-0">
      <div style={{ fontSize: "7pt", letterSpacing: "0.25em" }} className="text-[#E6A15C] uppercase">A new kind of wedding coverage</div>
      <div className="font-serif leading-none mt-1" style={{ fontSize: "19pt" }}>Incognito<br />Paparazzi</div>
      <div className="font-serif italic text-neutral-300 mt-1" style={{ fontSize: "8pt" }}>The photographer you'll never see.</div>
      <div className="mt-2 text-neutral-400" style={{ fontSize: "6.5pt", letterSpacing: "0.15em" }}>SCOTT BURTON PHOTOGRAPHY</div>
      <div className="text-neutral-500 truncate" style={{ fontSize: "6pt" }}>{short}</div>
    </div>
  </div>
);

export default function PrintCard() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  const url = useMemo(() => `${window.location.origin}/incognito${ref ? `?ref=${encodeURIComponent(ref)}` : ""}`, [ref]);
  const short = url.replace(/^https?:\/\//, "");
  useEffect(() => { document.title = "Incognito cards — Scott Burton Photography"; }, []);

  return (
    <div className="min-h-screen bg-neutral-200 text-black print:bg-white" data-testid="print-card-page">
      <style>{"@page { size: letter; margin: 0.5in; } @media print { .no-print { display: none !important; } }"}</style>
      <div className="no-print max-w-[8.5in] mx-auto pt-10 pb-6 px-4 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-serif text-3xl">Incognito QR cards</h1>
          <p className="text-sm text-neutral-600 mt-1">
            Ten business cards per page (3.5 × 2 in). The QR code opens {ref ? <>the Incognito page credited to <b>{ref}</b></> : "the Incognito page"}.
            Print on card stock at 100% scale and cut along the edges.
          </p>
        </div>
        <button data-testid="print-cards-btn" onClick={() => window.print()} className="bg-black text-white rounded-full px-5 py-2.5 text-sm flex items-center gap-2">
          <Printer size={15} /> Print cards
        </button>
      </div>
      <div className="mx-auto bg-white shadow print:shadow-none grid grid-cols-2 gap-0 justify-center" style={{ width: "7in" }} data-testid="print-card-sheet">
        {Array.from({ length: 10 }, (_, i) => <Card key={i} url={url} short={short} />)}
      </div>
      <div className="no-print h-16" />
    </div>
  );
}
